import React from "react";

/**
 * 统一的小节容器：灰底标题栏 + 细边框，和航班信息网格风格一致。
 * flush=true 时内容区无内边距，给自带分隔线的网格或列表（如检查项行）使用。
 */
export default function Section({ title, extra, mobile = false, flush = false, children, style }) {
    return (
        <div style={{ border: "1px solid #d9d9d9", borderRadius: 8, overflow: "hidden", marginBottom: 12, background: "#fff", ...style }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 8,
                    background: "#fafafa",
                    padding: "8px 12px",
                    borderBottom: "1px solid #f0f0f0",
                    fontWeight: 600,
                    color: "#595959",
                    fontSize: mobile ? 14 : 13,
                }}
            >
                <span>{title}</span>
                {extra ?? null}
            </div>
            <div style={{ padding: flush ? 0 : 12 }}>{children}</div>
        </div>
    );
}
